'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = matchesType;

var _isArray = require('lodash/isArray');

var _isArray2 = _interopRequireDefault(_isArray);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function matchesType(targetType, draggedItemType) {
	if ((0, _isArray2.default)(targetType)) {
		return targetType.some(function (t) {
			return t === draggedItemType;
		});
	} else {
		return targetType === draggedItemType;
	}
}


//////////////////
// WEBPACK FOOTER
// ./~/dnd-core/lib/utils/matchesType.js
// module id = 466
// module chunks = 2